import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/waffers/vanilla waffer.png";
import BiscuitImg from "../../../assets/products/waffers/Vanilla-Waffers.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 6,
  },
  {
    grams: 7,
  },
  {
    grams: 16,
  },
  {
    grams: 18,
  },
];

export default function VannilaWafferProduct() {
  return (
    <>
      <Helmet>
        <title>Vanilla Waffer – BearBitz | Premium Wafers & Biscuits</title>
        <meta
          name="description"
          content="Explore BearBitz Vanilla Wafers — light, crispy wafers with creamy vanilla filling. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Vanilla Waffer, BearBitz Vanilla Wafers"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/waffers/vannilawaffer"
        />
        <meta property="og:title" content="Vanilla Waffer – BearBitz" />
        <meta
          property="og:description"
          content="Buttery, crispy vanilla cream wafer biscuit by BearBitz designed for premium quality and export readiness."
        />
      </Helmet>

      <ProductTemplate
        productTitle="VANILLA"
        productImage={BisImg}
        description="Rolled for Flavor, Baked for Crunch Delicious cylindrical wafer rolls packed with rich cream fillings, offering a delightful crunch with every bite. Available in various tempting flavors, they make for a premium snacking experience and a perfect pairing with beverages. Popular in gift packs and premium retail shelves across global markets."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#BF9109"
        sectionBgColor="#FFF3D9"
        productBgcolor="#FFD683"
        tableheadBgcolor="#BF9109"
        tableBgcolor="#FFFAF0"
        footerBgcolor="#BF9109"
      />
    </>
  );
}
